/**
 * Helpers WOW-845: permisos y máscara de exportación en el front.
 * Export = función (blockedFeatures) + acceso al módulo fuente.
 */

const STAFF_ROLES = new Set(['ADMIN', 'COLABORADOR', 'SUPER_COLABORADOR']);

export const EXPORT_UNMASKED_ID = 'export_unmasked';

/** export_* → módulo(s) fuente. Sincronizar con smart_back export-function-permissions.ts */
export const EXPORT_PARENT_MODULE_MAP = {
  export_libro_mayor: 'libro_mayor',
  export_libro_diario: 'libro_diario',
  export_conciliacion: 'conciliacion',
  export_eerr: 'eerr',
  export_flujo_caja: 'flujo_caja',
  export_reportes_cobranza: 'reportes_cobranza',
  export_reportes_proveedores: 'reportes_proveedores',
  export_reportes_ventas: 'documentos_tributarios',
  export_reportes_compras: 'documentos_tributarios',
  export_agenda: 'agenda',
  export_eoaf: 'eoaf',
  export_documentos: 'documentos_tributarios',
  export_api_movimientos: 'conciliacion',
  export_api_documentos: 'documentos_tributarios',
  export_api_remuneraciones: 'reportes_rrhh',
  export_api_libro_mayor: 'libro_mayor',
  export_api_contactos: 'agenda',
  export_api_reportes: [
    'reportes_ventas',
    'reportes_compras',
    'reportes_cobranza',
    'reportes_proveedores',
    'reportes_dj',
    'reportes_rrhh',
    'reportes_personalizados',
  ],
};

export function isStaffUser(roles) {
  if (!Array.isArray(roles)) return false;
  return roles.some((r) => STAFF_ROLES.has(r));
}

function hasParentModuleAccess(exportModuleId, hasModuleAccess) {
  const parent = EXPORT_PARENT_MODULE_MAP[exportModuleId];
  if (!parent) return false;
  const parents = Array.isArray(parent) ? parent : [parent];
  return parents.some((id) => hasModuleAccess?.(id));
}

/**
 * ¿Puede exportar? Módulo fuente + export_* no bloqueado en blockedFeatures.
 * export_unmasked: grant opt-in en blockedFeatures del usuario.
 */
export function checkHasExportAccess(exportModuleId, { hasModuleAccess, blockedFeatures = [], userBlockedFeatures = [] }) {
  if (!exportModuleId) return false;
  if (exportModuleId === EXPORT_UNMASKED_ID) {
    const userBf = Array.isArray(userBlockedFeatures) ? userBlockedFeatures : blockedFeatures;
    return userBf.includes(EXPORT_UNMASKED_ID);
  }
  if (!hasParentModuleAccess(exportModuleId, hasModuleAccess)) return false;
  const list = Array.isArray(blockedFeatures) ? blockedFeatures : [];
  return !list.includes(exportModuleId);
}

/**
 * Default sin máscara. Solo enmascara si `forceMasked === true`.
 */
export function resolveExportMaskedFlag({ forceMasked } = {}) {
  return forceMasked === true;
}

/** Mapa recurso UI → permiso export_* */
export const EXPORT_MODULE_BY_RESOURCE = {
  libro_mayor: 'export_libro_mayor',
  libro_diario: 'export_libro_diario',
  conciliacion: 'export_conciliacion',
  eerr: 'export_eerr',
  flujo_caja: 'export_flujo_caja',
  cobranza: 'export_reportes_cobranza',
  proveedores: 'export_reportes_proveedores',
  ventas: 'export_reportes_ventas',
  compras: 'export_reportes_compras',
  agenda: 'export_agenda',
  eoaf: 'export_eoaf',
  documentos: 'export_documentos',
  rendiciones: 'export_documentos',
};

/** Tipo del form Libro Compras/Ventas/… → permiso export_* */
export function resolveExportModuleForDocumentBookType(type) {
  const t = String(type || '').toUpperCase();
  if (t === 'RECEIVED') return 'export_reportes_compras';
  if (t === 'GIVEN') return 'export_reportes_ventas';
  return 'export_documentos';
}
